import actions from "./actions";

const {
    FETCH_SALARY_MONTH_DECLARATIONS,
    FETCH_SALARY_MONTH_DECLARATION,
    RESET_SALARY_MONTH_DECLARATION
} = actions;

const initState = {
    salaryMonthDeclarations: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    salaryMonthDeclaration: { _id: null }
};

const SalaryMonthDeclarationReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_SALARY_MONTH_DECLARATIONS:
            return {
                ...state,
                salaryMonthDeclarations: data
            };
        case RESET_SALARY_MONTH_DECLARATION:
            return {
                ...state,
                salaryMonthDeclaration: initState.salaryMonthDeclaration
            };
        case FETCH_SALARY_MONTH_DECLARATION:
            return {
                ...state,
                salaryMonthDeclaration: data
            };
        default:
            return state;
    }
};

export default SalaryMonthDeclarationReducer;
